import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import JsonData from "../data/data.json";
import "../App.css";
import TagManager from 'react-gtm-module';


const PaginaNaoEncontrada = () => {
  useEffect(() => {
    const tagManagerArgs = {
        gtmId: 'GTM-TX3VDHC'
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <h1>404 - Página não encontrada</h1>
        <p>A página que você tentou acessar não existe.</p>
        <Link to="/">Voltar para a página inicial</Link>
    </div>
  );
};  

export default PaginaNaoEncontrada;
